import { createContext, useContext, useEffect, useRef } from 'react';

import { PopupGroupContextValue } from './PopupGroup.types';

export const PopupGroupContext = createContext<PopupGroupContextValue | null>(null);

const usePopupGroupContextValue = (): PopupGroupContextValue => {
    const context = useContext(PopupGroupContext);

    if (!context) {
        throw new Error('usePopupGroupContext must be used within PopupGroup');
    }

    return context;
};

export const usePopupGroupContext = (
    popupHovered: boolean,
    containerHovered?: boolean
): [boolean] => {
    const { currentPopupId, registerPopup } = usePopupGroupContextValue();
    const id = useRef(Math.random().toString());

    useEffect(() => {
        if (popupHovered) {
            registerPopup(id.current);
        }

        if (!popupHovered && currentPopupId === id.current) {
            registerPopup(null);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [popupHovered, containerHovered]);

    const isVisibleInGroup = popupHovered && currentPopupId === id.current;

    return [currentPopupId ? isVisibleInGroup : popupHovered];
};
